export default __webpack_public_path__ + "static/media/closePink.4d57c566.svg";